var map = {
	"./1.jpg": "eb2d",
	"./2.jpg": "dd7c",
	"./3.jpg": "9dc4",
	"./4.jpg": "5f1e",
	"./5.jpg": "1c0a",
	"./50.svg": "f798",
	"./6.jpg": "2ae8",
	"./7.jpg": "bf81",
	"./8.jpeg": "36c1",
	"./9.jpeg": "65eb",
	"./academy-hero-background.svg": "ae17",
	"./academy-hero-img.svg": "cbf0",
	"./academy.png": "5164",
	"./award.svg": "36c2",
	"./biznis.png": "dd04",
	"./blockchain.png": "5d6b",
	"./check.svg": "3174",
	"./cz-partners-CTK.png": "1639",
	"./cz-partners-E15.png": "2184",
	"./cz-partners-aktualne.png": "c169",
	"./cz-partners-blesk.svg": "0a42",
	"./cz-partners-czechcrunch.svg": "d6b7",
	"./cz-partners-finex.png": "16b0",
	"./cz-partners-finmag.svg": "ff9b",
	"./cz-partners-hospodarske_noviny.png": "2ae1",
	"./cz-partners-idnes.png": "7231",
	"./cz-partners-investplus.png": "629f",
	"./cz-partners-penize-cz.png": "56b8",
	"./cz-partners-reflex.png": "86f7",
	"./cz-partners-zive.png": "ed14",
	"./empty.svg": "fe9f",
	"./facebook.svg": "a165",
	"./financer.png": "bf62",
	"./forbes.png": "3091",
	"./full.svg": "5b8f",
	"./graph.svg": "f22d",
	"./hnonline.png": "49dd",
	"./instagram.svg": "67e7",
	"./krypto.png": "ce9d",
	"./ledger.png": "a696",
	"./letter.svg": "b466",
	"./linkedin.svg": "684b",
	"./lock.svg": "93e8",
	"./lsgs.png": "f714",
	"./man-silueta.png": "9426",
	"./partners-FT.png": "94be",
	"./partners-blockchain.png": "0483",
	"./partners-financer.png": "e7fe",
	"./partners-fintechhub.png": "070e",
	"./partners-fintree.png": "7b23",
	"./partners-ledger.png": "4d31",
	"./partners-sapie.jpeg": "faba",
	"./partners-sgs.png": "371f",
	"./play.svg": "c453",
	"./sgs.svg": "f7ec",
	"./sk-partners-HN.png": "e7c4",
	"./sk-partners-biznis_klub.png": "c33a",
	"./sk-partners-dennik-n.svg": "0cb7",
	"./sk-partners-forbes.png": "79d1",
	"./sk-partners-kryptomagazin.png": "11a5",
	"./sk-partners-novy-cas.png": "08d3",
	"./sk-partners-refresher.png": "5b02",
	"./sk-partners-sme.png": "06a6",
	"./sk-partners-startitup.png": "134a",
	"./sk-partners-ta3.png": "512b",
	"./sk-partners-tasr.png": "fa18",
	"./sk-partners-teraz.png": "6319",
	"./sk-partners-trend.png": "cd920",
	"./sk-partners-zoznam.svg": "d5b9",
	"./startitup.png": "9c41",
	"./ta3.png": "624d",
	"./tasr.png": "8217",
	"./teraz.png": "a695",
	"./testimonials-icon-blue.svg": "14cf",
	"./testimonials-icon-green.svg": "b6d8",
	"./testimonials-icon-green2.svg": "b26e",
	"./testimonials-icon-orange.svg": "7dda",
	"./testimonials-icon-orange2.svg": "63af",
	"./testimonials-icon-red.svg": "d741",
	"./trend.png": "c99b",
	"./triangle.png": "76aa",
	"./twitter.svg": "7989",
	"./user.png": "903d",
	"./video.png": "33c4",
	"./woman-silueta.png": "75bf",
	"./youtube.svg": "8af4",
	"./zoznam.png": "dc99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "781a";